import { useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'

import useGetCampaignList from './api/useGetCampaignList'

export interface CheckInEventItem {
  campaignId: string | null
  fromDate?: string | null
  toDate?: string | null
}

export const CheckInEventAtom = atom<CheckInEventItem>({
  key: 'CheckInEventAtom',
  default: {
    campaignId: '',
  },
})

const useCheckInEventForm = () => {
  const [form, setForm] = useRecoilState(CheckInEventAtom)
  const { campaigns } = useGetCampaignList()

  // first setup for search
  useEffect(() => {
    if (campaigns?.length === 0) return
    const latestCampaingn = campaigns?.reduce((prev, current) => (prev.startDate > current.startDate ? prev : current))
    setForm({
      campaignId: latestCampaingn?.campaignId.toString() ?? '',
      fromDate: latestCampaingn?.startDate.split(' ')[0],
      toDate: latestCampaingn?.endDate.split(' ')[0],
    })
  }, [campaigns, setForm])

  return { form, setForm }
}

export default useCheckInEventForm
